import { render, staticRenderFns } from "./ComplieRightMenuRule.vue?vue&type=template&id=b5de428c&scoped=true"
import script from "./ComplieRightMenuRule.vue?vue&type=script&lang=js"
export * from "./ComplieRightMenuRule.vue?vue&type=script&lang=js"
import style0 from "./ComplieRightMenuRule.vue?vue&type=style&index=0&id=b5de428c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5de428c",
  null
  
)

export default component.exports